function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { CALL_API } from "../middleware/api";
export var POST_HASHTAGFOLLOWER_REQUEST = "POST_HASHTAGFOLLOWER_REQUEST";
export var POST_HASHTAGFOLLOWER_SUCCESS = "POST_HASHTAGFOLLOWER_SUCCESS";
export var POST_HASHTAGFOLLOWER_FAILURE = "POST_HASHTAGFOLLOWER_FAILURE";
export var RESET_POST_HASHTAGFOLLOWER = "RESET_POST_HASHTAGFOLLOWER";
export var postHashtagFollower = function postHashtagFollower(hashtagFollower) {
  var endpoint = "hashtagFollowers";
  if (hashtagFollower.id) endpoint += "/".concat(hashtagFollower.id);
  return _defineProperty({
    hashtagFollower: hashtagFollower
  }, CALL_API, {
    types: [POST_HASHTAGFOLLOWER_REQUEST, POST_HASHTAGFOLLOWER_SUCCESS, POST_HASHTAGFOLLOWER_FAILURE],
    endpoint: endpoint,
    init: {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(hashtagFollower),
      credentials: "same-origin"
    }
  });
};
export var DELETE_HASHTAGFOLLOWER_REQUEST = "DELETE_HASHTAGFOLLOWER_REQUEST";
export var DELETE_HASHTAGFOLLOWER_SUCCESS = "DELETE_HASHTAGFOLLOWER_SUCCESS";
export var DELETE_HASHTAGFOLLOWER_FAILURE = "DELETE_HASHTAGFOLLOWER_FAILURE";
export var RESET_DELETE_HASHTAGFOLLOWER = "RESET_DELETE_HASHTAGFOLLOWER";
export var deleteHashtagFollower = function deleteHashtagFollower(hashtagFollower) {
  return _defineProperty({
    hashtagFollower: hashtagFollower
  }, CALL_API, {
    types: [DELETE_HASHTAGFOLLOWER_REQUEST, DELETE_HASHTAGFOLLOWER_SUCCESS, DELETE_HASHTAGFOLLOWER_FAILURE],
    endpoint: "hashtagFollowers/".concat(hashtagFollower.id),
    init: {
      method: "DELETE",
      credentials: "same-origin"
    }
  });
};